export { createNavigationConfig } from './create-navigation-config';
